<template>
  <vs-sidebar
    :click-not-close="!closeable"
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    :style="{ '--relative-size': relativeSize }"
    :value="isActive"
    @input="$emit('update:isActive', $event)"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <div class="flex items-center">
        <slot name="header"></slot>
      </div>
      <feather-icon
        icon="XIcon"
        @click.stop="$emit('update:isActive', false)"
        class="cursor-pointer"
      ></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new pb-8"
      :settings="settings"
      :key="$vs.rtl"
    >
      <slot name="content"></slot>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <slot name="footer"></slot>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "normal",
    },
    closeable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:isActive"],
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    relativeSize() {
      if (this.size === "large") return "944px";
      if (this.size === "medium") return "600px";
      return "400px";
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: var(--relative-size);
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>